import { render } from "./index.vue?vue&type=template&id=2c45590b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2c45590b&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c45590b"]])

export default __exports__